import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { authAPI } from '../api/auth';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      loading: false,

      login: async (credentials) => {
        set({ loading: true });
        try {
          // 后端返回 ApiResult<LoginResponse>，拦截器已解包为 LoginResponse
          // LoginResponse: { token, expiresIn, userId, nickname, avatar, role, creditBalance }
          const loginRes = await authAPI.login(credentials);
          const { token, nickname, avatar, userId, role, creditBalance } = loginRes;
          const user = { nickname, avatar, userId, role, creditBalance };
          set({ token, user, loading: false });
          return loginRes;
        } catch (err) {
          set({ loading: false });
          throw err;
        }
      },

      register: async (data) => {
        set({ loading: true });
        try {
          const registerRes = await authAPI.register(data);
          const { token, nickname, avatar, userId, role, creditBalance } = registerRes;
          const user = { nickname, avatar, userId, role, creditBalance };
          set({ token, user, loading: false });
          return registerRes;
        } catch (err) {
          set({ loading: false });
          throw err;
        }
      },

      wechatLogin: async (code) => {
        set({ loading: true });
        try {
          const loginRes = await authAPI.wechatLogin(code);
          const { token, nickname, avatar, userId, role, creditBalance } = loginRes;
          const user = { nickname, avatar, userId, role, creditBalance };
          set({ token, user, loading: false });
          return loginRes;
        } catch (err) {
          set({ loading: false });
          throw err;
        }
      },

      logout: () => {
        set({ token: null, user: null });
      },

      setToken: (token) => set({ token }),
      setUser: (user) => set({ user }),

      /** 未登录（401）时由请求层广播，同步清空内存中的登录态 */
      clearCredentials: () => set({ token: null, user: null }),

      /** 检查 token 是否有效 */
      isAuthenticated: () => {
        const { token } = get();
        if (!token) return false;
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          return payload.exp * 1000 > Date.now();
        } catch {
          return true;
        }
      },
    }),
    {
      name: 'simon-cat-auth',
      partialize: (state) => ({ token: state.token, user: state.user }),
    }
  )
);

// 请求层遇到 401 时广播该事件，这里同步清空内存中的登录态（不跳转页面）
if (typeof window !== 'undefined') {
  window.addEventListener('simon-cat:unauthorized', () => {
    useAuthStore.getState().clearCredentials();
  });
}